<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhone_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.733 12.373c-.382.679-1.125 1.154-1.988 1.274-1.66.231-3.792-.788-6.198-3.193-2.94-2.94-3.36-4.993-3.193-6.198.119-.863.595-1.606 1.274-1.988a1.13 1.13 0 0 1 1.532.406l1.293 2.155a1.136 1.136 0 0 1-.171 1.39l-.606.624c.448.728.957 1.345 1.547 1.934a12.59 12.59 0 0 0 1.887 1.558l.675-.621a1.132 1.132 0 0 1 1.386-.168l2.155 1.293c.53.32.71.993.407 1.534Z"
    />
</svg>
